import { useState } from "react";
import { Switch } from "./ui/switch";
import { toast } from "sonner";
import { api, money, formatApiError, startCheckout } from "../lib/api";

export const AutopayCard = ({ m, ts, pricing, onDone }) => {
  const [busy, setBusy] = useState(false);
  const full = pricing?.full_fee;
  const auto = pricing?.autopay_fee;
  const toggle = async (enabled) => {
    if (enabled && !window.confirm(`Turn on autopay? You'll be charged ${money(auto)} today (adds 30 days) and monthly after that.`)) return;
    setBusy(true);
    try {
      if (enabled) return await startCheckout({ kind: "membership", tier: m.tier, plan: m.plan, level: m.level, autopay: true });
      await api.post(`/memberships/${m.tier}/autopay-off`);
      toast.success("Autopay off — your paid time stays the same");
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="autopay-card" className="lux-card p-6 flex items-center justify-between gap-4">
      <div>
        <p className="eyebrow">Automatic payments · save {ts.autopay_discount_pct}%</p>
        <p className="text-sm text-slate-300 mt-2">
          <span className="font-mono-lux text-[#38BDF8]">{money(auto)}</span>/mo instead of <span className="font-mono-lux line-through text-slate-500">{money(full)}</span>. Never lose your spot.
        </p>
      </div>
      <Switch data-testid="autopay-switch" checked={!!m.autopay} disabled={busy || m.status !== "active"} onCheckedChange={toggle} />
    </div>
  );
};
